import { NoTransformConfigurationError } from './transformers/NoTransformConfigurationError.mjs';

/* ===========================================================
    MISCELLANEOUS
      - LITERALS
      - CLONE
      - PRUNE
      - FACTORY FUNCTIONS
==============================================================
    LITERALS
----------------------------------------------------------- */
/**
 * @internal
 */
function literals() {
    NoTransformConfigurationError("misc.literals");
}
/**
 * @internal
 */
function clone() {
    NoTransformConfigurationError("misc.clone");
}
/**
 * @internal
 */
function assertClone() {
    NoTransformConfigurationError("misc.assertClone");
}
/**
 * @internal
 */
function isClone() {
    NoTransformConfigurationError("misc.isClone");
}
/**
 * @internal
 */
function validateClone() {
    NoTransformConfigurationError("misc.validateClone");
}
/**
 * @internal
 */
function prune() {
    NoTransformConfigurationError("misc.prune");
}
/**
 * @internal
 */
function assertPrune() {
    NoTransformConfigurationError("misc.assertPrune");
}
/**
 * @internal
 */
function isPrune() {
    NoTransformConfigurationError("misc.isPrune");
}
/**
 * @internal
 */
function validatePrune() {
    NoTransformConfigurationError("misc.validatePrune");
}
/**
 * @internal
 */
function createClone() {
    NoTransformConfigurationError("misc.createClone");
}
/**
 * @internal
 */
function createAssertClone() {
    NoTransformConfigurationError("misc.createAssertClone");
}
/**
 * @internal
 */
function createIsClone() {
    NoTransformConfigurationError("misc.createIsClone");
}
/**
 * @internal
 */
function createValidateClone() {
    NoTransformConfigurationError("misc.createValidateClone");
}
/**
 * @internal
 */
function createPrune() {
    NoTransformConfigurationError("misc.createPrune");
}
/**
 * @internal
 */
function createAssertPrune() {
    NoTransformConfigurationError("misc.createAssertPrune");
}
/**
 * @internal
 */
function createIsPrune() {
    NoTransformConfigurationError("misc.createIsPrune");
}
/**
 * @internal
 */
function createValidatePrune() {
    NoTransformConfigurationError("misc.createValidatePrune");
}

export { assertClone, assertPrune, clone, createAssertClone, createAssertPrune, createClone, createIsClone, createIsPrune, createPrune, createValidateClone, createValidatePrune, isClone, isPrune, literals, prune, validateClone, validatePrune };
//# sourceMappingURL=misc.mjs.map
